export const hourChecker = (hour: string) => +hour > 0 && +hour <= 24 && hour.length <= 2
export const minuteChecker = (minute: string) => +minute >= 0 && +minute < 60 && minute.length <= 2